import { render } from "./CustFooter.vue?vue&type=template&id=a505b41e&scoped=true"
import script from "./CustFooter.vue?vue&type=script&lang=js"
export * from "./CustFooter.vue?vue&type=script&lang=js"

import "./CustFooter.vue?vue&type=style&index=0&id=a505b41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a505b41e"]])

export default __exports__